exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-gif {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: rgba(152, 152, 152, 0.72);\n  top: 0;\n  z-index: 4;\n  display: block;\n  margin: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center; }\n  .container-gif div {\n    position: absolute;\n    display: block;\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    box-shadow: 0 3px 0 0 #d9272e;\n    animation: uil-ring-anim 1s linear infinite; }\n\n@keyframes uil-ring-anim {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/partialLoader/partial-loader.component.scss
// module id = ../../../../../app/shared/components/partialLoader/partial-loader.component.scss
// module chunks = main